import React, { Component } from 'react'
import { getNavItemStyle, getPath } from './util'
import { NavItemContainer } from './navItem.container'
import { CategoriesContainer } from './Categories.container'

export class NavigationContainer extends Component {
  constructor() {
    super()
    this.state = {
      isOpen: false,
      items: [],
    }
  }

  componentWillUpdate(nextProps, nextState) {
    document.body.classList.toggle('no-scroll', nextState.isOpen)
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
  }

  closeMenu() {
    this.setState({ isOpen: false })
  }

  manageMenu(navItem, index) {
    if (this.state.isOpen) {
      this.closeMenu()
    } else {
      this.props.mobileNavigationAnalyticsMenuClicked(navItem.analytics, index)
      this.setState({ isOpen: true, items: navItem.items })
    }
  }

  renderCategories() {
    return (
      <CategoriesContainer
        categories={this.state.items}
        isOpen={this.state.isOpen}
        closeMenu={() => this.closeMenu()}
      />
    )
  }

  isLinkNavItemMatch(url) {
    let path = getPath()
    return path !== '/' && url === path
  }

  isMenuNavItemOpen(categories) {
    return this.state.isOpen && categories !== null
  }

  isLinkNavItemSelected(url, categories) {
    return this.isLinkNavItemMatch(url) && categories === null && !this.state.isOpen
  }

  getNavItemBottomBorderStyle(url, categories) {
    return this.isMenuNavItemOpen(categories) || this.isLinkNavItemSelected(url, categories)
  }

  renderNavigation(navItems) {
    return navItems.map((navItem, index) =>
      <div
        className={[
          getNavItemStyle(navItems.length),
          this.getNavItemBottomBorderStyle(navItem.url, navItem.items)
            ? 'nav__item__selected_border'
            : 'nav__item__border',
        ].join(' ')}
        key={index}
      >
        <NavItemContainer
          description={navItem.description}
          icon={navItem.icon}
          analytics={navItem.analytics}
          url={navItem.url}
          isHaveCategories={navItem.items !== null ? true : false}
          isOpen={this.state.isOpen}
          selectedNavItem={getPath()}
          index={index}
          onCategorySelected={() => {
            this.manageMenu(navItem, index)
          }}
        />
      </div>
    )
  }

  render() {
    return (
      <div
        className={`mobile-nav-main-wrapper ${this.props.shouldShowNavigation
          ? 'mobile-nav-main-wrapper__opened'
          : 'mobile-nav-main-wrapper__closed'}`}
        style={{ marginTop: `${this.props.topAdMargin}px` }}
      >
        <div className="nav__wrapper">
          {this.renderNavigation(this.props.config)}
        </div>
        {this.renderCategories()}
      </div>
    )
  }
}

NavigationContainer.defaultProps = {
  shouldShowNavigation: true,
  topAdMargin: 0,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/Navigation.container.js